import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SliceSettingsComponent } from "./model/slice-settings/slice-settings.component";
import { SharedModule } from "../shared/shared.module";
import { SliceSettingsChartComponent } from "./model/slice-settings-chart/slice-settings-chart.component";
import { SliceChartContainerComponent } from "./model/model-chart-container/model-chart-container.component";
import { ChartSliceComponent } from "./project/chart-slice/chart-slice.component";
import { MaterialModule } from "../shared/material.module";
import { ShotSelectContainerComponent } from "./shot/shot-select-container/shot-select-container.component";
import { ShotsGraphComponent } from "./project/shot-image/shots-graph/shots-graph.component";
import { ShotChartContainerComponent } from "./shot/shot-chart-container/shot-chart-container.component";
import { ShotChartComponent } from "./shot/shot-chart/shot-chart.component";
import { ShotContainerComponent } from "./shot/shot-container/shot-container.component";
import { D3ImageComponent } from "./project/shot-image/d3-image/d3-image.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatTableModule,
  MatCheckboxModule,
  MatRadioModule,
} from "@angular/material";
import { SliceChartMenuComponent } from "./model/model-chart-menu/model-chart-menu.component";
import { ShotTabsComponent } from "./shot/shot-tabs/shot-tabs.component";
import { ShotSelectChartMenuComponent } from "./shot/shot-select-chart-menu/shot-select-chart-menu.component";
import { ShotBlockSettingsComponent } from "./shot/shot-block-settings/shot-block-settings.component";
import { ProjectSettingsBarComponent } from "./project/project-settings-bar/project-settings-bar.component";
import { ShotChartMenuComponent } from "./shot/shot-chart-menu/shot-chart-menu.component";
import { ShotContainerMenuComponent } from "./shot/shot-container-menu/shot-container-menu.component";
import { ShotChartLegendComponent } from "./shot/shot-chart-legend/shot-chart-legend.component";
import { ShotSelectFormComponent } from "./shot/shot-select-form/shot-select-form.component";
import { TablesComponent } from "./project/tables/tables.component";
import { ProjectTableComponent } from "./project-view/project-table/project-table.component";
import { ParameterOverviewComponent } from "./project-view/parameter-overview/parameter-overview.component";
import { DragulaModule } from "ng2-dragula";
import { FlowchartComponent } from "./project-view/flowchart/flowchart.component";
import { DataTableComponent } from "./project-view/data-table/data-table.component";
import { ImagePanelComponent } from "./project-view/image-panel/image-panel.component";
import { RouterModule } from "@angular/router";
import { CustomTableComponent } from "./project-view/data-table/custom-table/custom-table.component";
import { ModelTableComponent } from "./project-view/model-table/model-table.component";
import { ParameterOverview2Component } from "./project-view/parameter-overview-2/parameter-overview-2.component";
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    DragulaModule,
    RouterModule,
  ],
  declarations: [
    SliceSettingsComponent,
    SliceSettingsChartComponent,
    SliceChartContainerComponent,
    ChartSliceComponent,
    ShotsGraphComponent,
    ShotSelectContainerComponent,
    ShotChartContainerComponent,
    ShotChartComponent,
    ShotContainerComponent,
    D3ImageComponent,
    SliceChartMenuComponent,
    ShotTabsComponent,
    ShotSelectChartMenuComponent,
    ShotBlockSettingsComponent,
    ProjectSettingsBarComponent,
    ShotChartMenuComponent,
    ShotContainerMenuComponent,
    ShotChartLegendComponent,
    ShotSelectFormComponent,
    TablesComponent,
    ProjectTableComponent,
    ParameterOverviewComponent,
    FlowchartComponent,
    DataTableComponent,
    ImagePanelComponent,
    CustomTableComponent,
    ModelTableComponent,
    ParameterOverview2Component,
  ],
  exports: [
    SliceSettingsComponent,
    SliceChartContainerComponent,
    ChartSliceComponent,
    ShotsGraphComponent,
    ShotSelectContainerComponent,
    ShotChartContainerComponent,
    ShotChartComponent,
    ShotContainerComponent,
    D3ImageComponent,
    ShotBlockSettingsComponent,
    ProjectSettingsBarComponent,
    ShotChartMenuComponent,
    ShotContainerMenuComponent,
    ShotChartLegendComponent,
    ShotSelectFormComponent,
    TablesComponent,
    ProjectTableComponent,
  ],
})
export class ProjectModule {}



// WEBPACK FOOTER //
// ./src/app/projects/project.module.ts